import React, { HTMLAttributes } from "react";
import type { IStoredPaymentMethod } from "../../../apis/subscription/type";
import BaseLabel from "../baseLabel";
import BaseTextInput from "../baseTextInput";

interface IAdyenStoredCard {
  storedPaymentMethods?: IStoredPaymentMethod | null;
}

type TAdyenStoredCardProps = IAdyenStoredCard & HTMLAttributes<HTMLDivElement>;

const AdyenStoredCard: React.FC<TAdyenStoredCardProps> = (props) => {
  const { storedPaymentMethods, ...otherProps } = props;

  if (storedPaymentMethods?.status !== 404) {
    return (
      <div className="flex flex-col items-start gap-4 mb-4">
        <BaseLabel text="已綁定的信用卡" />
        <div className="flex flex-col gap-4 text-white w-full">
          <BaseTextInput
            placeholder="信用卡號碼"
            value={`xxxx xxxx xxxx ${storedPaymentMethods?.lastFour}`}
            disabled
          />
          <BaseTextInput
            placeholder="信用卡到期日"
            value={`${storedPaymentMethods?.expiryMonth}/${storedPaymentMethods?.expiryYear}`}
            disabled
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="text-white">
        <BaseLabel text="沒有已綁定的信用卡" />
      </div>
    );
  }
};

export default AdyenStoredCard;
